import { useEffect, useState } from "react";
import { Calendar, Views } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { localizer, getMessages } from "../../../helpers";
import { useScheduleStore, useScheduleConfig } from "../../hooks";
import { SelectSlotModal } from "../modals";

export const Schedule = ({ handleSelectEvent }) => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    schedule,
  } = useScheduleStore();

  const { scheduleEvents: scheduleEventsSchedule } = schedule;

  const {
    // Props
    isMobile,
    views,
    isSelectSlotModal,

    // Methods
    eventPropGetter,
    setCurrentView,
    setCurrentNavigate,
    setIsSelectSlotModal,
  } = useScheduleConfig({
    scheduleEvents: schedule.scheduleEvents,
  });

  // States ------------------------------------------------//
  const [scheduleEvents, setScheduleEvents] = useState([]);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    const newscheduleEvents = scheduleEventsSchedule.map((scheduleEvent) => ({
      ...scheduleEvent,
      start: new Date(scheduleEvent.start),
      end: new Date(scheduleEvent.end),
    }));

    setScheduleEvents(newscheduleEvents);
  }, [scheduleEventsSchedule]);

  return (
    <>
      <Calendar
        dayLayoutAlgorithm="no-overlap"
        culture="es"
        localizer={localizer}
        events={scheduleEvents}
        startAccessor="start"
        endAccessor="end"
        style={{
          height: isMobile
            ? "calc(100vh - 170px)"
            : "clamp(500px, calc(100vh - 200px), 600px)",
        }}
        messages={getMessages()}
        defaultView={Views.WEEK}
        views={views}
        onSelectEvent={handleSelectEvent}
        onNavigate={setCurrentNavigate}
        onView={setCurrentView}
        //   scrollToTime={new Date(new Date().setHours(7, 0, 0))}
        step={10}
        eventPropGetter={eventPropGetter}
        min={new Date(1970, 0, 1, 6, 0)}
        max={new Date(1970, 0, 1, 18, 0)}
      />

      <SelectSlotModal
        isOpen={isSelectSlotModal}
        setIsOpen={setIsSelectSlotModal}
      />
    </>
  );
};
